export const keyIsTab = (event) => {
    return event.key === 'Tab' || event.code === 'Tab';
};
export const keyIsEscape = (event) => {
    return event.key === 'Escape' || event.code === 'Escape';
};
